var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SPage,{scopedSlots:_vm._u([{key:"lateral-panel",fn:function(){return [_c(_setup.SLateralPanel,[(_vm.isInRole('Administrateur'))?_c(_setup.EtablissementCreateDialog):_vm._e()],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }